<template>
    <div>
        <Header/>
        <div class="container-product">
            <kt-row class="mt-4">
                <kt-col xs="12" md="4">
                    <kt-panel >
                        <kt-panel-header>
                            <img class="product-bimg d-block img-fluid"

                                 :src="product.image" alt="">
                            <img :style="styles.storeLogo" :src="product.store_logo_link" alt="">
                        </kt-panel-header>
                    </kt-panel>
                    <kt-panel>
                        <kt-panel-body>
                            <span class="mt-4 pl-3 pt-1" :style="styles.productTitle">{{ product.title }}</span>
                            <span class="ml-2 mt-2" :style="styles.storeName">فروشگاه {{ product.store_name }}</span>

                            <span v-if="!product.define_amount_by_user" class="d-block mx-auto mt-3 font-weight-bold text-danger" :style="styles.productAmount">
                            {{ product.amount }} ریال
                        </span>
                        </kt-panel-body>
                    </kt-panel>
                    <kt-panel>
                        <kt-panel-body >
                            <div>
                                <kt-input-group v-if="product.is_multiple">
                                    <kt-button @click="plusQuantity()"><kt-icon name="plus"></kt-icon></kt-button>
                                    <kt-form-control
                                            class="mx-2 text-center"
                                            type="number" name="quantity"
                                            :max="product.quantity"
                                            v-model="quantity">
                                    </kt-form-control>
                                    <kt-button @click="minusQuantity()">
                                        <kt-icon name="minus"></kt-icon>
                                    </kt-button>
                                </kt-input-group>

                                <span
                                        v-if="!product.unlimited"
                                        class="d-block mt-3 text-center text-muted">
                                {{ product.quantity }} عدد از این محصول موجود است
                            </span>
                            </div>
                            <kt-button
                                    class="m-2 btn-block btn-boldest btn-pill"
                                    size="md"
                                    variant="success"
                                    type="submit"
                                    v-bind:wide="true"
                                    id="cart_btn"
                                    @click="addCart({
                                    id:product.id,
                                    title:product.title,
                                    image:product.image,
                                    amount:product.amount,
                                    cart:quantity,
                                    discount_max:product.discount_max,
                                    discount_percent:product.discount_percent,
                                    discount_value:product.discount_value,
                                    quantity:product.quantity,
                                    tags:product.tags,
                                    description:product.description,

                            })" >
                                {{ $t('btn.cart') }}
                            </kt-button>
                        </kt-panel-body>

                    </kt-panel>
                </kt-col>
                <kt-col xs="12" md="8">
                    <product-page-form :submitForm="submitForm" ></product-page-form>

                    <h2>درباره این محصول بیشتر بدانید</h2>
                    <p class="mt-3" style="font-size:15px;line-height:2rem;">
                        {{ product.description }}
                    </p>
                </kt-col>
            </kt-row>
        </div>
    </div>

</template>

<script>
import ProductPageForm from './components/product-page-form'
import Header from './components/header'
import { mapGetters } from 'vuex'

export default {
    components: {
        ProductPageForm,
        Header,
    },
    data() {
        return {
            quantity: 1,
            hashid: this.$route.params.product_hashid,
            store_slug: this.$route.params.store,
            styles: {

                storeLogo: {
                    position: 'absolute',
                    width: '60px',
                    minHeight: '60px',
                    height: 'auto',
                    left: '25px',
                    top: '15px',
                    borderRadius: '3px',
                    border: '1px solid #d0cdcd',
                },
                productTitle: {
                            borderRight: '2px solid #212529',
                            fontSize: '17px'
                        },
                        storeName: {
                            color: '#797979',
                            fontSize: '13px'
                        },
                        productAmount: {
                            fontSize: '22px'

                        }
            }
        }
    },
    beforeRouteEnter (to, from, next) {
        next(vm => {
            vm.$store.dispatch('product/publicAccess', {
                store: vm.store_slug,
                hashid: vm.hashid,
            })
        })
    },
    computed: {
        ...mapGetters('product', [
            'product', 'status'
        ]),
        ...mapGetters('cart', [
            'cart'
        ]),

    },
    methods: {
        addCart(product){
            if (!JSON.stringify(this.cart).includes(JSON.stringify(product))){
                this.$store.dispatch('cart/add',product)
                localStorage.setItem('allCart',JSON.stringify(this.cart))
            }


        },
        submitForm() {

        },
        minusQuantity() {
            if(this.quantity > 0) {
                this.quantity = parseInt(this.quantity) - 1
            }
        },
        plusQuantity() {
            if(this.quantity < this.product.quantity) {
                this.quantity = parseInt(this.quantity) + 1
            }
        }
    }
}
</script>

<style>
.container-product{
    padding: 30px 120px;
}
.product-bimg{
        border-radius: 5px;
        min-height: 60px;
        margin: 20px 0;
}
@media (max-width: 576px) {
    .container-product{
        padding: 10px 15px;
    }
}

</style>